import React, { useState, useEffect } from 'react'
import Heros from "../components/Heros";
import AboutImg from "../assets/img7.jpg"
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import axios from "axios";
// import { Link } from "react-router-dom";

export default function About() {
  const [break_bulk, setBreak_bulk] = useState([]);
  const [columns, setColumns] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Format column name for display (snake_case to Title Case)
  const formatColumnName = (column) => {
    return column
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  useEffect(() => {
    setIsLoading(true);
    setError(null);

    // First fetch the schema to get all visible columns
    axios
      .get("https://site2.akms.org.in/api/break-bulk/schema")
      .then((schemaResult) => {
        // Convert API response to our column format and filter only visible ones
        const visibleColumns = schemaResult.data
          .filter(col => col.VISIBLE !== false) // Only include visible columns
          .map(col => col.COLUMN_NAME);
        
        setColumns(visibleColumns);
        
        // Then fetch the vessels data
        return axios.get("https://site2.akms.org.in/api/break-bulk");
      })
      .then((vesselsResult) => {
        setBreak_bulk(vesselsResult.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
        setError("Failed to load fleet data. Please try again later.");
        setIsLoading(false);
      });
  }, []);

  return (
    <>
      <Navbar Home="Home" About="Fleet List" Contact="Enquiry" Fleet="Break Bulk" PCTC="PCTC" More="Schedule" IntraAsia="Intra-Asia" Bay_Bengal="Bay of Bengal" Login="Login" PCTC2="PCTC"></Navbar>
    
      <Heros
        cName="hero-mid"
        heroImg={AboutImg}
        url="/"
      ></Heros>

      <div style={{backgroundColor: "black"}}>
        <br></br>
        <h1 className="head" style={{ color: "#fff", textAlign: "center" }}>
          Fleet List
        </h1>
        <br></br>
        
        {isLoading ? (
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-12 text-center" style={{ color: "#fff", padding: "20px" }}>
                Loading fleet data...
              </div>
            </div>
          </div>
        ) : error ? (
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-12 text-center" style={{ color: "#fff", padding: "20px" }}>
                {error}
              </div>
            </div>
          </div>
        ) : (
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            {/* Dynamically render column headers based on available columns */}
                            {columns.map((column) => (
                              <th
                                key={column}
                                scope="col"
                                style={{ 
                                  color: "#fff", 
                                  textAlign: "center", 
                                  backgroundColor: "#36304a",
                                  position: "sticky",
                                  top: 0,
                                  zIndex: 1
                                }}
                              >
                                {formatColumnName(column)}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody className="text-center">
                          {break_bulk.length === 0 ? (
                            <tr>
                              <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                No vessels found.
                              </td>
                            </tr>
                          ) : (
                            break_bulk.map((item) => (
                              <tr key={item.id || item._id}>
                                {columns.map((column) => (
                                  <td 
                                    key={`${item.id || item._id}-${column}`}
                                    title={`${formatColumnName(column)}: ${item[column] || ''}`}
                                    style={{
                                      cursor: "default",
                                      position: "relative"
                                    }}
                                  >
                                    {item[column] || ''}
                                  </td>
                                ))}
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <br></br>
      </div>
   
      <Footer></Footer>

      {/* CSS for tooltip behavior */}
      <style jsx>{`
        .table th {
          position: sticky;
          top: 0;
          z-index: 10;
        }
        
        .table td:hover::after {
          content: attr(title);
          position: absolute;
          left: 0;
          top: -30px;
          background: #36304a;
          color: white;
          padding: 5px 10px;
          border-radius: 3px;
          white-space: nowrap;
          z-index: 20;
          box-shadow: 0 2px 5px rgba(0,0,0,0.2);
          font-size: 12px;
        }
      `}</style>
    </>
  )
}